import React from 'react'
// import Header from './components/Header'
import './Header.css'

const Header = () => {
  return (
    <div className="header">
        <div className="name">
            <h1>jai patil</h1>

        </div>
        <div className="center">
            <h1>about</h1>
            <h1>projects</h1>

        </div>
        <div className="contact">
            <h1>contact me</h1>
        </div>

      
    </div>
  )
}

export default Header
